import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AppLayout     from './components/layout/AppLayout';
import Landing       from './pages/Landing';
import LandingOdontologia     from './pages/LandingOdontologia';
import LandingGinecologia     from './pages/LandingGinecologia';
import LandingOncologia       from './pages/LandingOncologia';
import LandingMedicinaInterna from './pages/LandingMedicinaInterna';
import Login         from './pages/Login';
import Dashboard     from './pages/Dashboard';
import Pacientes     from './pages/Pacientes';
import Turnos        from './pages/Turnos';
import Historia      from './pages/Historia';
import Laboratorio   from './pages/Laboratorio';
import Facturacion   from './pages/Facturacion';
import Farmacia      from './pages/Farmacia';
import Odontograma   from './pages/Odontograma';
import Reportes      from './pages/Reportes';
import ResultadosPortal from './pages/ResultadosPortal';
import VerificarFirma from './pages/VerificarFirma';

function PrivateRoute({ children }) {
  const { usuario } = useAuth();
  return usuario ? children : <Navigate to="/bienvenida" replace />;
}

// Protege una ruta según el tipo_usuario del JWT
// Si el usuario no tiene permiso, lo redirige al Dashboard
function RolRoute({ children, roles }) {
  const { usuario } = useAuth();
  if (!usuario) return <Navigate to="/login" replace />;
  if (roles.includes('*')) return children;
  const tipo = usuario.esDBA ? 'DBA' : (usuario.tipo_usuario || 'MEDICO').toUpperCase().trim();
  if (roles.includes(tipo)) return children;
  return <Navigate to="/" replace />;
}

// DEMO: no existe ninguna ruta "configuracion" — ni por URL directa se
// puede llegar ahí, cae al catch-all de abajo y regresa al Dashboard.
export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/bienvenida" element={<Landing />} />
          <Route path="/odontologia" element={<LandingOdontologia />} />
          <Route path="/ginecologia" element={<LandingGinecologia />} />
          <Route path="/oncologia" element={<LandingOncologia />} />
          <Route path="/medicina-interna" element={<LandingMedicinaInterna />} />
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<PrivateRoute><AppLayout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="pacientes" element={
              <RolRoute roles={['*']}><Pacientes /></RolRoute>
            } />
            <Route path="turnos" element={
              <RolRoute roles={['MEDICO','SECRETARIA','DBA','ADMINISTRADOR']}><Turnos /></RolRoute>
            } />
            <Route path="historia" element={
              <RolRoute roles={['MEDICO','DBA','ADMINISTRADOR']}><Historia /></RolRoute>
            } />
            <Route path="laboratorio" element={
              <RolRoute roles={['LABORATORIO','DBA','ADMINISTRADOR']}><Laboratorio /></RolRoute>
            } />
            <Route path="facturacion" element={
              <RolRoute roles={['SECRETARIA','LABORATORIO','DBA','ADMINISTRADOR']}><Facturacion /></RolRoute>
            } />
            <Route path="farmacia" element={
              <RolRoute roles={['LABORATORIO','SECRETARIA','DBA','ADMINISTRADOR']}><Farmacia /></RolRoute>
            } />
            <Route path="odontograma" element={
              <RolRoute roles={['MEDICO','DBA','ADMINISTRADOR']}><Odontograma /></RolRoute>
            } />
            <Route path="reportes" element={
              <RolRoute roles={['DBA','ADMINISTRADOR','SECRETARIA']}><Reportes /></RolRoute>
            } />
          </Route>
          <Route path="/resultados/:token" element={<ResultadosPortal/>}/>
          <Route path="/verificar/:nro/:hash" element={<VerificarFirma/>}/>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
